import { isEmpty } from 'lodash';
import { VectorConfigurationData } from '../Vector/types/vectorDataChartTypes';
import { DotMenuCustomOptions } from '@/common/components/DotMenu/DotMenu';
import { redirectToVDEDataExplorerPage } from '../../common/domains';
import { addDays, startOfDay, subDays } from 'date-fns';

export const ALARM_LEVELS = {
  CriticalAlarm: 'Critical',
  NonCriticalAlarm: 'Non-Critical',
};

export function isSameItem(currentItem, selectedItem) {
  if (stringifyWithDates(currentItem) === stringifyWithDates(selectedItem)) {
    return true;
  }
  return false;
}

export function stringifyWithDates(obj: {}) {
  return JSON.stringify(obj, (key, value) => {
    return value instanceof Date ? value?.toISOString() : value;
  });
}

export const getTypesFromObject = (obj: VectorConfigurationData | {}) => {
  return Object.values(obj)?.flatMap((category) =>
    Object.entries(category?.['members'] || [])
      .filter(([_, member]) => member?.['selected'])
      .map(([type]) => type),
  );
};

export const selectAllProperties = (obj: VectorConfigurationData | {}) => {
  if (isEmpty(obj) || !('eventTypes' in obj)) return {};
  return Object.keys(obj.eventTypes)?.reduce((acc, typeKey) => {
    acc[typeKey] = {
      ...obj.eventTypes[typeKey]!,
      members: Object.keys(obj.eventTypes[typeKey].members)?.reduce(
        (acc2, memberKey) => {
          acc2[memberKey] = {
            ...obj.eventTypes[typeKey]?.members[memberKey],
            selected: true,
          };
          return acc2;
        },
        {},
      ),
    };
    return acc;
  }, {});
};

export const generateDotMenuOptions = (
  item,
  navigate,
  dispatch,
  externalId,
  setContextEventDetails,
): DotMenuCustomOptions[] => {
  return [
    {
      title: 'Click to navigate to Data Explorer',
      label: 'Data Explorer',
      onClickFn: (event) => {
        event.stopPropagation();
        redirectToVDEDataExplorerPage(
          navigate,
          externalId,
          subDays(startOfDay(item.time), 3),
          addDays(startOfDay(item.time), 4),
        );
      },
    },
    {
      title: 'Click to show context',
      label: 'Show context',
      icon: 'lely-icon-show',
      onClickFn: (event) => {
        event.stopPropagation();
        setContextEventDetails(item);
      },
    },
  ];
};
